import { clients } from 'lib/https';
import { SidebarItem } from 'components/blocks/layout/types/sidebar-conversation';
import { ConfigurationSettings } from '../../models/configuration-settings';

export interface ChatApiResponse {
  results: SidebarItem[];
  total_count: number;
  message: string;
  status: string;
}

export interface ArchiveApiResponse {
  modified_count: number;
  message: string;
  status: string;
}

export interface ArchivedChatsParams {
  pageSize?: number;
  page?: number;
}

export const getArchivedChats = async (
  param: ArchivedChatsParams,
  config: ConfigurationSettings
): Promise<ChatApiResponse> => {
  const baseUrl = `https://${config.paths.baseUrl}`;
  return clients.get(
    `${baseUrl}${config.paths.taskforce.conversationList}?page=${param.page}&page_size=${param.pageSize}&is_archived=true`,
    config.blocksKey
  );
};

export const unArchiveChat = async (
  conversationId: string,
  config: ConfigurationSettings
): Promise<ArchiveApiResponse> => {
  const baseUrl = `https://${config.paths.baseUrl}`;
  return clients.post(
    `${baseUrl}${config.paths.taskforce.unarchive}`,
    config.blocksKey,
    JSON.stringify({
      conversation_id: conversationId,
    })
  );
};
